import axios from "axios";
import toastr from "toastr";
// You can use your own logic to set your local or production domain
const localDomain = "https://localhost:5001/api/v1/";
const testDomain = "http://botracer.ru:5000/api/v1/";
const prodDomain = "http://45.141.103.232:5000/api/v1/";
// The base URL is empty this time due we are using the jsonplaceholder API
const baseURL = `${prodDomain}`;

const instance = axios.create({
  baseURL
});

instance.interceptors.request.use(
  request => {
    request.headers.Authorization =
      "Bearer " + window.localStorage.getItem("token");
    return request;
  },
  error => error
);
instance.interceptors.response.use(response => response, errorHandler);

function errorHandler(error) {
  if (!error.response) return Promise.reject(error);
  switch (error.response.status) {
    case 401:
      window.location.href = window.location.origin + "/#/login";
      break;
    case 400:
      console.log(error.response.data)
      var key = Object.keys(error.response.data.errors)[0];
      var messages = `${key}: ${error.response.data.errors[key]}`;
      toastr.error(messages, "Ошибка!");
      break;
    case 500:
      toastr.error("Ошибка сервера");
      break;
    default:
      toastr.error(error.response.data.message, "Ошибка!");
  }

  return Promise.reject(error);
}

export default instance;



// WEBPACK FOOTER //
// ./src/apiServices/client.js